import React, {Component} from 'react';
import styled from "styled-components";

import EditJson from "./content/EditJson.jsx";
import EditCatalog from "./content/EditCatalog.jsx";
import EditTopics from "./content/EditTopics.jsx";
import EditWebsite from "./content/EditWebsite.jsx";
import EditCrew from "./content/EditCrew.jsx";

import StoreS3 from './util/StoreS3.jsx';
import Common from './util/Common.jsx';

const PageWrapper = styled.div`
    font-family: Arial;
    font-size: 1rem;
    overflow: hidden;
    height: 100%;
    width: 100%;
`;

const TitleBar = styled.div`
    margin: 1rem;
    border-bottom: 0.15rem solid #aaaaaa;
    width: calc(100% - 2rem);
`;

const TitleText = styled.div`
    display: inline-block;
    font-size: 1.5rem;
    color: #cccccc;
    letter-spacing: 0.5rem;
`;

const LeftSidebar = styled.div`
    display: inline-block;
    border-right: 0.15rem solid #aaaaaa;
    margin-left: 1rem;
    width: 10%;
`;

const PageBody = styled.div`
    display: inline-block;
    margin-left: 1rem;
    width: 85%;
    vertical-align: top;
`;

const PageContent = styled.div`
    width: 100%;
`;

const MenuTitle = styled.div`
    display: inline-block;
    font-size: 0.9rem;
    text-transform: uppercase;
    font-weight: bold;
    letter-spacing: 0.25rem;
    margin-bottom: 0.5rem;
`;

const MenuItem = styled.div`
    margin-bottom: 0.25rem;
    margin-left: 0.5rem;
    cursor: pointer;
`;

const EditLink = styled.div`
    display: inline-block;
    font-size: 0.65rem;
    font-color: blue;
    opacity: 0;
`;

const PublishButton = styled.button`
    float: right;
    font-size: 1rem;
    margin-bottom: 0.25rem;
`;

export class Manifest extends Component {
    state = {
        main: {},
        main_str: "",
        page_body: "page_body_a"
    };

    componentDidMount() {
        document.title = "MHS Manifest";
        this.load_directory();
    }

    async load_directory() {
        const main = await StoreS3.get_file('main.json');
        this.setState({
            main: JSON.parse(main.Body),
            main_str: main.Body,
            page_body: <EditCatalog/>
        });
    }

    hover_edit(e, is_over) {
        e.target.style.opacity = is_over ? 1 : 0;
    }

    save_menu_text(text) {
        StoreS3.put_file("main.json", text);
        this.setState({
            page_body: "saved!",
            main: JSON.parse(text),
            main_str: text
        });
    }

    edit_directory(e) {
        this.setState({
            page_body: <EditJson
                text={this.state.main_str}
                save_handler={(text) => this.save_menu_text(text)}
                cancel_handler={() => this.setState({page_body: "canceled"})}/>
        })
    }

    click_menu(folder) {
        switch (folder) {
            case 'catalog':
                this.setState({page_body: <EditCatalog/>})
                break;
            case 'topics':
                this.setState({page_body: <EditTopics/>})
                break;
            case 'website':
                this.setState({page_body: <EditWebsite/>})
                break;
            case 'crew':
                this.setState({page_body: <EditCrew/>})
                break;
            default:
                break;
        }
    }

    format_date () {
        const d = new Date();
        const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
        const month = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
        const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
        const hour = new Intl.DateTimeFormat('en', { hour: 'numeric' }).format(d);
        const minute = new Intl.DateTimeFormat('en', { minute: '2-digit' }).format(d);
        const second = new Intl.DateTimeFormat('en', { second: '2-digit' }).format(d);
        return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
    }

    async publish_manifest() {
        console.log("collecting data...");
        const manifest = {
            catalog: await StoreS3.get_file_tree("catalog"),
            topics: await StoreS3.get_file_tree("topics"),
            website: await StoreS3.get_file_tree("website")
        }
        console.log("ready to publish manifest:", manifest);
        const string_form = JSON.stringify(manifest);
        const this_date = Common.format_date();
        await StoreS3.put_file("manifest.json", string_form);
        await StoreS3.put_file(`archive/manifest-${this_date}.json`, string_form);
        console.log("publish complete, archived as " + this_date);
    }

    render() {
        const main = this.state.main;
        if (!main.menu) {
            return 'loading...';
        }
        const title_bar = <TitleBar>
            <TitleText>{main.title}</TitleText>
            <PublishButton onClick={e => this.publish_manifest()}>publish</PublishButton>
        </TitleBar>
        const left_sidebar = main.menu.map((entry, index) =>
            <MenuItem
                key={"sidebar_" + index}
                onClick={e => this.click_menu(entry.folder)}>
                {entry.title}
            </MenuItem>
        );
        const edit_link = <EditLink
            onMouseOver={e => this.hover_edit(e, true)}
            onMouseOut={e => this.hover_edit(e, false)}
            onClick={e => this.edit_directory(e)}>
            edit
        </EditLink>
        return <PageWrapper>
            {title_bar}
            <PageContent>
                <LeftSidebar>
                    <MenuTitle>directory</MenuTitle>
                    {edit_link}
                    {left_sidebar}
                </LeftSidebar>
                <PageBody>
                    {this.state.page_body}
                </PageBody>
            </PageContent>
        </PageWrapper>
    }
}

export default Manifest;
